import BaseModel from '../base';
import TeamMember from './member';
import TeamPattern from './pattern';
import constants, { TEAM_STATUS } from './constants';
import glossary, { TEAM_STATUS_DATA } from './glossary';
import { TEAM_MEMBER_STATUS } from './member/constants';

export default class EventTeam extends BaseModel {
  constructor(team = {}, url = 'teams') {
    super(team, url);

    Object.assign(this, team);
    const status = Number(team.status?.id ?? team.status);

    this.description = team.description || null;
    this.searchable = team.searchable ?? false;
    this.event_id = team.event_id ?? null;
    this.nomination_id = team.nomination_id ?? null;
    this.group_id = team.group_id ?? null;
    this.team_pattern_id = team.team_pattern_id ?? null;
    this.captain_id = team.captain_id ?? null;
    this.owner_id = team.owner_id ?? null;
    this.organizer_id = team.organizer_id ?? null;
    this.status = Object.values(TEAM_STATUS).includes(status)
      ? status
      : TEAM_STATUS.STATUS_DRAFT;
    this.complete = team.complete ?? false;
    this.created_at = team.created_at || null;
    this.updated_at = team.updated_at || null;
    this.avatar = team.avatar || null;
    this.members = (team.members || [])
      .map((member) => new TeamMember(member))
      .filter(({ status: memberStatus }) => ![
        TEAM_MEMBER_STATUS.STATUS_REJECTED,
        TEAM_MEMBER_STATUS.STATUS_LEFT,
        TEAM_MEMBER_STATUS.STATUS_EXCLUDED,
      ].includes(Number(memberStatus)));
    this.members_count = Array.isArray(team.members)
      ? this.members.length
      : team.members_count ?? 0;
    this.team_pattern = team.team_pattern
      ? new TeamPattern(team.team_pattern)
      : null;
  }

  get statusData() {
    return TEAM_STATUS_DATA[this.status] || TEAM_STATUS_DATA[TEAM_STATUS.STATUS_DRAFT];
  }

  get isDraft() {
    return this.status === TEAM_STATUS.STATUS_DRAFT;
  }

  get isSubmitted() {
    return !this.isDraft;
  }

  get isAccepted() {
    return this.status === TEAM_STATUS.STATUS_ACTIVE;
  }

  get canManageApplication() {
    return !this.isAccepted;
  }

  canChangeMembers(nomination = this.nomination) {
    if (this.isDraft) return true;
    return this.isAccepted && Boolean(nomination?.options?.can_change_team_members);
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
